import type { Feature } from '@exodus/dependency-types';

import blinksApiDefinition from './api.js';
import blinkActionsAtomDefinition from './atoms/actions.js';
import appsAtomDefinition from './atoms/apps.js';
import blinksDefinition from './module.js';
import blinksPluginDefinition from './plugin.js';

const blinks = () =>
  ({
    id: 'blinks',
    definitions: [
      {
        definition: blinkActionsAtomDefinition,
        storage: { namespace: 'blinks' },
        aliases: [
          { interfaceId: 'storage', implementationId: 'unsafeStorage' },
        ],
      },
      { definition: appsAtomDefinition },
      { definition: blinksDefinition },
      { definition: blinksPluginDefinition },
      { definition: blinksApiDefinition },
    ],
  }) satisfies Feature;

export default blinks;
